const origin = window.location.origin;

// 通过域名格式来判定环境
const env = {
  isTest: /.qa|(\.qa)/.test(origin),
  isDev: /-dev|(\.dev)/.test(origin),
  isRelease: /-release|(\.release)/.test(origin)
};

//缓存用
const getCurrentEvn = () => {
  if (env.isTest) {
    return 'test';
  }
  if (env.isDev) {
    return 'dev';
  }
  if (env.isRelease) {
    return 'release';
  }
  return 'pro';
};
//域名跳转用
const getDomainEnvName = () => {
  if (env.isTest) {
    return `-qa`;
  }
  if (env.isDev) {
    return '-dev';
  }
  if (env.isRelease) {
    return '-release';
  }
  return '';
};

//云译客官网域名
const getTranspaceDomain = () => {
  if (env.isTest) {
    return 'http://transpace.qa.iol8.net';
  }
  if (env.isDev) {
    return 'http://transpace.dev.iol8.net';
  }
  if (env.isRelease) {
    return 'http://transpace.release.iol8.net';
  }

  return 'https://transpace.iol8.com';
};

//云译客项目管理域名
export const getPeDomain = () => {
  if (env.isTest) {
    return 'http://pe.qa.iol8.net';
  }
  if (env.isDev) {
    return 'http://pe.dev.iol8.net';
  }
  if (env.isRelease) {
    return 'http://pe.release.iol8.net';
  }
  return 'https://pe.iol8.com';
};

// 言值录招募地址
export const getWpDomain = () => {
  if (env.isTest) {
    return 'http://wp.qa.iol8.net';
  }
  if (env.isDev) {
    return 'http://wp.dev.iol8.net';
  }
  if (env.isRelease) {
    return 'http://wp.release.iol8.net';
  }
  return 'https://wp.iol8.com';
};

// 经过cas中转后的跳转地址
export const getCasWpDomain = (backurl: string) => {
  const currEvn = getCurrentEvn();
  let serviceUrl = '';
  if (currEvn === 'dev') {
    serviceUrl = `http://passport.dev.iol8.net/cas/login?service=${backurl}`;
  } else if (currEvn === 'test') {
    serviceUrl = `http://passport.qa.iol8.net/cas/login?service=${backurl}`;
  } else if (currEvn === 'release') {
    serviceUrl = `http://passport.release.iol8.net/cas/login?service=${backurl}`;
  } else {
    serviceUrl = `https://passport.iol8.com/cas/login?service=${backurl}`;
  }

  return serviceUrl;
};

// talent web跳转地址
export const getTalentDomain = () => {
  if (env.isTest) {
    return 'https://talent.qa.iol8.net';
  }
  if (env.isDev) {
    return 'https://talent.dev.iol8.net';
  }
  return 'https://talent.iol8.com';
};

// 获取cloud的baseUrl
export const getCloudBaseUrl = () => {
  if (env.isTest) {
    // const regex = /^[a-z]+-([a-z0-9]+)\./i;
    // const match = window.location.hostname.match(regex);
    // const environment = match ? match[1] : 'qa';
    // return `//cloud.${environment}.iol8.net`;
    return '//cloud.qa.iol8.net';
  }
  if (env.isDev) {
    return '//cloud.dev.iol8.net';
  }
  if (env.isRelease) {
    return '//cloud.release.iol8.net';
  }
  return '//cloud.iol8.com';
};

// cloud域名接口包装
export const wrapCloud = (config: any) => {
  return {
    baseURL: getCloudBaseUrl(),
    ...config
  };
};

export const wpDomain = getWpDomain();
export const peDomain = getPeDomain();
export const cloudBaseUrl = getCloudBaseUrl();
export const currEvn = getCurrentEvn();
export const currDomainEnv = getDomainEnvName();
export const transpaceDomain = getTranspaceDomain();
